import React from 'react'
import { Table } from 'antd'
import { Switch } from 'antd';
import gql from 'graphql-tag'
import { RouteComponentProps } from 'react-router-dom'
import { useTitle } from '@/utils/hooks'
import { LlmChatQueueQuery, useLlmChatQueueQuery } from './__gen'
import { ProcessButton } from './process-button'
import { SetResponseHtmlButton } from './set-response-html-button'

gql`
	query llmChatQueue {
		llmChatAdmin_List(annotateLastMessage: true, orderBy: [{ field: lastMessage, direction: DESC }]) {
			objects {
				id
				created
				lastMessage
				minutesSinceLastMessage
				processedAt
				recordId
				formId
				
			}
		}
	}
`

type Chat = NonNullable<LlmChatQueueQuery['llmChatAdmin_List']>['objects'][number]

const formatDatetime = (value: string | null) => {
	if (!value) return '—'
	const d = new Date(value)
	return d.toLocaleString(undefined, {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
	})
}

const columns = [
	{
		title: 'ID',
		dataIndex: 'id',
		key: 'id',
	},
	{
		title: 'Created',
		dataIndex: 'created',
		key: 'created',
		render: (v: string) => formatDatetime(v),
	},
	{
		title: 'Processed At',
		dataIndex: 'processedAt',
		key: 'processedAt',
		render: (v: string | null, chat: Chat) => (
			<>
				<ProcessButton id={chat.id} processedAt={v} />
				<br />
				{v ? formatDatetime(v) : ''}
			</>
		),
	},
	{
		title: 'Response Html',
		dataIndex: 'responseHtml',
		key: 'responseHtml',
		render: (v: string | null, chat: Chat) => (
				<SetResponseHtmlButton chat={chat} />
		),
	},
	{
		title: 'Last Message',
		dataIndex: 'lastMessage',
		key: 'lastMessage',
		render: (v: any) => formatDatetime(v),
	},
	{
		title: 'Minutes Since Last Message',
		dataIndex: 'minutesSinceLastMessage',
		key: 'minutesSinceLastMessage',
	},
]

export const LlmChatQueue = ({ match }: RouteComponentProps<{}>) => {
	useTitle('Super User - Queue')
	const { data, loading, error } = useLlmChatQueueQuery()
	const chats = data?.llmChatAdmin_List?.objects ?? []
	return (
		<>
			<h2>Unprocessed Llm Chats</h2>
			<Table<Chat>
				columns={columns}
				dataSource={chats}
				rowKey="id"
				loading={loading}
				pagination={false}
				size="small"
				locale={{ emptyText: 'No chats waiting to be processed' }}
			/>
			{error && <p>Error: {error.message}</p>}
		</>
	)
}
